import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Testimonials({ items = [] }) {
  const [idx, setIdx] = useState(0);
  if (!items.length) return null;
  const t = items[idx];
  const go = (d) => setIdx((p) => (p + d + items.length) % items.length);

  return (
    <section className="bg-background py-24 md:py-32 overflow-hidden" data-testid="testimonials-section">
      <div className="rb-container">
        <Reveal className="text-center mb-14">
          <p className="overline text-accent-foreground/60 mb-4">Voices of Rythmbara</p>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-foreground">
            Stories told through movement.
          </h2>
        </Reveal>

        <div className="relative max-w-4xl mx-auto text-center">
          <Quote className="mx-auto h-14 w-14 text-[var(--rb-gold)] opacity-40 mb-6" />
          <AnimatePresence mode="wait">
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.5 }}
              data-testid="testimonial-active"
            >
              <p className="font-serif italic font-light text-2xl md:text-4xl leading-snug text-foreground">
                “{t.quote}”
              </p>
              <div className="mt-8 flex items-center justify-center gap-1">
                {Array.from({ length: t.rating || 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-[var(--rb-gold)] text-[var(--rb-gold)]" />
                ))}
              </div>
              <p className="mt-5 font-medium text-lg text-foreground">{t.name}</p>
              <p className="overline text-[10px] text-muted-foreground mt-1">{t.role}</p>
            </motion.div>
          </AnimatePresence>

          <div className="mt-12 flex items-center justify-center gap-4">
            <button onClick={() => go(-1)} data-testid="testimonial-prev" aria-label="Previous"
              className="grid h-12 w-12 place-items-center border border-border hover:bg-purple hover:text-[#F6F4EE] transition-colors duration-300">
              <ChevronLeft className="h-5 w-5" />
            </button>
            <div className="flex gap-2">
              {items.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)} aria-label={`Go to testimonial ${i + 1}`}
                  className={`h-2 transition-all duration-300 ${i === idx ? "w-8 bg-[var(--rb-gold)]" : "w-2 bg-border"}`} />
              ))}
            </div>
            <button onClick={() => go(1)} data-testid="testimonial-next" aria-label="Next"
              className="grid h-12 w-12 place-items-center border border-border hover:bg-purple hover:text-[#F6F4EE] transition-colors duration-300">
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
